/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Invalid_DescInputs */

const vi_einvoice_credential_invalid_desc = /** @type {(inputs: Einvoice_Credential_Invalid_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết nối MISA cần kiểm tra lại.`)
};

/**

* @param {Einvoice_Credential_Invalid_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_invalid_desc = /** @type {((inputs?: Einvoice_Credential_Invalid_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Invalid_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_invalid_desc(inputs)
});